import { useTranslation } from "react-i18next"
import useStore from "../../../store"
import NoResultsFound from "../../common/NoResultsFound"
import useUserType from "../../../hooks/useUserType"

export default function NoCurrentUnits() {
  const { t } = useTranslation()
  const { isEmployee } = useUserType()

  return(
    <div className="w-full bg-grey-900 rounded-md text-center">
      {isEmployee ?
        <NoResultsFound/>
        :
        <h3 className="font-header font-semibold text-md text-fpx-red">{t('No Current Units')}</h3>
      }
    </div>
  )
}